export default __webpack_public_path__ + "static/media/architecture_diagram.506c597e.png";